import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import ReportPage from './pages/ReportPage';
import InvestorPage from './pages/InvestorPage';
import InvestigationPage from './pages/InvestigationPage';
import PesonalInvestigationPage from './pages/PesonalInvestigationPage';
import LoginPage from './pages/LoginPage';

// ----------------------------------------------------------------------

export default function Router() {
  const type = localStorage.getItem('type');
  let routesContent;
  if (type === 'investor') {
    routesContent = [
      { path: '/', element: <ReportPage /> },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ];
  } else if (type === 'admin') {
    const id = localStorage.getItem('id');
    if (id === 'woosung') {
      routesContent = [
        { path: '/', element: <InvestorPage /> },
        { path: 'personalInvestigation', element: <PesonalInvestigationPage /> },
        {
          path: '*',
          element: <Navigate to="/" replace />,
        },
      ];
    } else {
      routesContent = [
        { path: '/', element: <InvestorPage /> },
        { path: 'investigation', element: <InvestigationPage /> },
        { path: 'personalInvestigation', element: <PesonalInvestigationPage /> },
        {
          path: '*',
          element: <Navigate to="/" replace />,
        },
      ];
    }
  } else {
    routesContent = [
      { path: '/', element: <LoginPage /> },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ];
  }

  const routes = useRoutes(routesContent);

  return routes;
}
